import { render, staticRenderFns } from "./SkuSelect.vue?vue&type=template&id=1cd0972e&scoped=true"
import script from "./SkuSelect.vue?vue&type=script&lang=js"
export * from "./SkuSelect.vue?vue&type=script&lang=js"
import style0 from "./SkuSelect.vue?vue&type=style&index=0&id=1cd0972e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0972e",
  null
  
)

export default component.exports